import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as l, normalizeClass as n, createElementVNode as r } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconSmartphone",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ r("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.5 1.5A.5.5 0 0 0 3 2v8a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 9 10V2a.5.5 0 0 0-.5-.5h-5ZM2 2A1.5 1.5 0 0 1 3.5.5h5A1.5 1.5 0 0 1 10 2v8a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 2 10V2Z",
  "clip-rule": "evenodd"
}, null, -1), h = /* @__PURE__ */ r("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.5 9a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), u = [
  _,
  h
];
function m(a, p, i, f, v, e) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--smartphone"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Smartphone",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, u, 10, c);
}
const A = /* @__PURE__ */ o(s, [["render", m]]);
export {
  A as default
};
//# sourceMappingURL=smartphone.js.map
